import { render } from "./ScenarioContent.vue?vue&type=template&id=2be1aba3"
import script from "./ScenarioContent.vue?vue&type=script&lang=js"
export * from "./ScenarioContent.vue?vue&type=script&lang=js"
script.render = render

export default script